import { WizardContext } from "../types/WizardContext";

export const CountChannelOptions = {
	name: "CountChannelOptions",
	description: "Creates a histogram for a data channel with fixed options.",
	parameters: {
		channel: {
			type:"string",
			drawer(context:WizardContext){
				return {
					type:"dropdown",
					options:getOptions(context.channels)
				}
			},
			default:null
		}
	},
	output:{
		values:{
			type:"number[]"
		},
		labels:{
			type:"string[]"
		}
	}
};

const countableTypes = [
	"form/dropdown",
	"form/multiplechoice",
	"form/linearscale/row",
	"gallery/feedback/scale",
];

const getOptions = (channels:any[]) => {
	const countable = channels.filter(c => countableTypes.findIndex(x => x === c.type) > -1);
	return countable
	.map(channel => {
		return {
			text: channel.name,
			value: channel.key,
		};
	});

};